export default function PrivacyPolicy() {
    return (
        <div className="min-h-screen bg-cream">
            <div className="max-w-4xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
                <div className="mb-12">
                    <h1 className="font-display text-5xl md:text-6xl font-extrabold tracking-tight mb-4">
                        Privacy Policy
                    </h1>
                    <p className="text-ink/60 font-body text-lg">
                        Last updated: June 3, 2026
                    </p>
                </div>

                <div className="prose prose-lg max-w-none font-body text-ink space-y-6">
                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">1. Introduction</h2>
                        <p>
                            Technovale Solutions ("we," "us," "our," or "Company") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and otherwise handle your information when you visit our website and use our services.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">2. Information We Collect</h2>
                        <p>We may collect information about you in a variety of ways, including:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li><strong>Personal Information:</strong> Name, email address, phone number, and other details you provide when contacting us or creating an account.</li>
                            <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and actions taken.</li>
                            <li><strong>Technical Data:</strong> IP address, browser type, device information, and cookies.</li>
                            <li><strong>Business Information:</strong> Company name, position, and industry for B2B interactions.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">3. How We Use Your Information</h2>
                        <p>We use the information we collect for:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Providing and improving our services</li>
                            <li>Communicating with you about inquiries and requests</li>
                            <li>Sending promotional materials and updates (with your consent)</li>
                            <li>Analyzing website usage and performance</li>
                            <li>Ensuring security and preventing fraud</li>
                            <li>Complying with legal obligations</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">4. Information Sharing</h2>
                        <p>
                            We do not sell, trade, or rent your personal information to third parties. We may share your information with:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Service providers who assist us in operating our website and conducting our business</li>
                            <li>Legal authorities when required by law</li>
                            <li>Business partners with your consent</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">5. Security</h2>
                        <p>
                            We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">6. Your Rights</h2>
                        <p>You have the right to:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Access the personal information we hold about you</li>
                            <li>Request correction of inaccurate data</li>
                            <li>Request deletion of your information</li>
                            <li>Opt out of marketing communications</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">7. Cookies</h2>
                        <p>
                            Our website uses cookies to enhance user experience and analyze website traffic. You can control cookie settings through your browser preferences.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">8. Contact Us</h2>
                        <p>
                            If you have questions about this Privacy Policy or our privacy practices, please contact us at:
                        </p>
                        <div className="mt-4 p-6 bg-ink/5 border-2 border-ink/20">
                            <p className="font-bold">Technovale Solutions</p>
                            <p>Email: info@technovalesolutions.com</p>
                            <p>Phone: +91 (931) 074-5117</p>
                            <p>Address: 188, Sector 48, Gurugram, HR</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
